import React from "react";

// eslint-disable-next-line react/require-default-props
function GoogleMediaIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_885_15494)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.80256 10.5C4.80256 9.8649 4.90804 9.25601 5.09631 8.6849L1.80097 6.16846C1.15872 7.47246 0.796875 8.94179 0.796875 10.5C0.796875 12.0569 1.15828 13.5253 1.79963 14.8285L5.09319 12.3071C4.9067 11.7387 4.80256 11.132 4.80256 10.5Z"
          fill="#FBBC05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5884 4.72217C11.9681 4.72217 13.2143 5.21106 14.1935 6.01106L17.042 3.16661C15.3062 1.6555 13.0808 0.722168 10.5884 0.722168C6.71887 0.722168 3.39326 2.93506 1.80078 6.16839L5.09612 8.68483C5.85542 6.37995 8.01982 4.72217 10.5884 4.72217Z"
          fill="#EB4335"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5884 16.2776C8.01982 16.2776 5.85542 14.6198 5.09612 12.3149L1.80078 14.8309C3.39326 18.0647 6.71887 20.2776 10.5884 20.2776C12.9766 20.2776 15.2568 19.4296 16.9681 17.8407L13.8401 15.4225C12.9575 15.9785 11.8461 16.2776 10.5884 16.2776Z"
          fill="#34A853"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9355 10.4999C19.9355 9.92217 19.8464 9.29995 19.7129 8.72217H10.5889V12.4999H15.8408C15.5782 13.7879 14.8634 14.7782 13.8406 15.4226L16.9686 17.8408C18.7662 16.1724 19.9355 13.6871 19.9355 10.4999Z"
          fill="#4285F4"
        />
      </g>
      <defs>
        <clipPath id="clip0_885_15494">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default GoogleMediaIcon;
